import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../utils/api";
import { FaSpinner, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();

  const ref = params.get("MerchantReference") || "";
  const [state, setState] = useState({ loading: true, ok: false, msg: "" });

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      if (!ref) {
        setState({ loading: false, ok: false, msg: "مرجع العملية غير موجود." });
        return;
      }

      try {
        // ✅ verify server-side (production safe)
        const r = await api.get(`/payment/verify?ref=${encodeURIComponent(ref)}`);

        if (!mounted) return;

        if (r.data?.success) {
          setState({ loading: false, ok: true, msg: r.data?.message || "تم الدفع بنجاح." });

          // ✅ لو السيرفر رجّع token (optional) نخش على طول
          if (r.data?.token) {
            localStorage.setItem("token", r.data.token);
            if (r.data?.role) localStorage.setItem("role", r.data.role);
            if (r.data?.userId) localStorage.setItem("userId", r.data.userId);
            setTimeout(() => nav("/dashboard"), 900);
            return;
          }

          // ✅ غير كده: ودّيه login
          setTimeout(() => nav("/login"), 1200);
          return;
        }

        setState({ loading: false, ok: false, msg: r.data?.message || "فشل التحقق من الدفع." });
      } catch (e) {
        setState({ loading: false, ok: false, msg: e?.response?.data?.message || "حدث خطأ أثناء التحقق." });
      }
    };

    run();
    return () => {
      mounted = false;
    };
  }, [ref, nav]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 text-yellow-400 text-xl">
        <FaSpinner className="animate-spin mr-2" /> جاري تأكيد الدفع...
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white px-6">
      <div className="max-w-lg w-full bg-gray-800/70 border border-yellow-500 rounded-2xl p-8 text-center">
        {state.ok ? (
          <>
            <FaCheckCircle className="text-green-400 text-6xl mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-green-300 mb-2">تم الدفع بنجاح ✅</h1>
            <p className="text-gray-300">{state.msg}</p>
            <p className="text-gray-400 text-sm mt-4">سيتم تحويلك الآن...</p>
          </>
        ) : (
          <>
            <FaTimesCircle className="text-red-400 text-6xl mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-red-300 mb-2">لم يتم تأكيد الدفع</h1>
            <p className="text-gray-300">{state.msg}</p>
            <button
              onClick={() => nav("/login")}
              className="mt-6 px-5 py-2 rounded-lg bg-yellow-500 hover:bg-yellow-600 text-black font-bold"
            >
              الرجوع لتسجيل الدخول
            </button>
          </>
        )}
      </div>
    </div>
  );
}
